export default "__VITE_ASSET__BT81mwId__"